import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { localized } from 'decorators'
import { ODataLoader } from 'components/dataLoader'
import { SimpleSelect } from './_simpleSelect'
import { buildLookupRequest } from 'utils/odata'

export const LookupSelect = (props) => {
  const buildRequest = (props, filter, skip) => buildLookupRequest((props.loadAll ? 0 : skip), (props.loadAll ? null : props.take), props.textField, filter, props.staticFilters, props.sortField)
  const [filter, setFilter] = useState('')
  const [skip, setSkip] = useState(0)
  const [request, setRequest] = useState(buildRequest(props, filter, skip))
  const [staticFilters, setStaticFilters] = useState(props.staticFilters)
  const [items, setItems] = useState([])
  
  useEffect(() => {
    if (staticFilters !== props.staticFilters) {
      setStaticFilters(props.staticFilters)
      setRequest(buildRequest(props, filter, skip))
    }
  },[staticFilters, filter, skip, props, props.staticFilters])
  
  const { take, onChange, ...otherProps } = props

  const renderDropDown = ({ loading, data = [], totalCount, error }) => {
    const handleInputChange = (value, e) => {
      if (e.action === 'input-change') {
        setFilter(value)
        setRequest(buildRequest(props, value, skip))
      }
    }
    const handleChange = (e, value) => {
      if (e === null) {
        setRequest(buildRequest(props, value, skip))
      }
      onChange(e, value)
    }
    const hasMore = totalCount > skip + data.length
    const handleMenuScrollToBottom = () => {
      if (hasMore) {
        if (data) { setItems([...items, ...data]) }
        const newSkip = skip + props.take
        setSkip(newSkip)
        setRequest(buildRequest(props, filter, newSkip))
      }
    }

    return (
      <SimpleSelect
        {...otherProps}
        data={[...items, ...data]}
        loading={loading || props.loading}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onMenuScrollToBottom={handleMenuScrollToBottom}
        />
    )
  }
  return (
    <ODataLoader
      dataSource={props.dataSource}
      request={request}
      render={renderDropDown} />
  )
}

LookupSelect.propTypes = {
  dataSource: PropTypes.func.isRequired,
  staticFilters: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  valueField: PropTypes.string,
  textField: PropTypes.string,
  getLabel: PropTypes.func,
  nullable: PropTypes.bool,
  take: PropTypes.number,
  sortField: PropTypes.string
}
LookupSelect.defaultProps = {
  valueField: 'id',
  textField: 'name',
  nullable: false,
  take: 20
}

export default localized(LookupSelect)
